export const DEFAULTS = {
	BRAND: '#5545E1',
	GOOD: '#32bd94',
	BAD: '#cc3939',
	NEUTRAL: '#5545E1',
};

export function getDefaults() {
	return { brand_color: DEFAULTS.BRAND, bad: DEFAULTS.BAD, good: DEFAULTS.GOOD, neutral: DEFAULTS.NEUTRAL };
}
